import { render, staticRenderFns } from "./Lesson8.vue?vue&type=template&id=2a015bfe&scoped=true&"
import script from "./Lesson8.vue?vue&type=script&lang=js&"
export * from "./Lesson8.vue?vue&type=script&lang=js&"
import style0 from "./Lesson8.vue?vue&type=style&index=0&id=2a015bfe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a015bfe",
  null
  
)

export default component.exports